import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  SSO_LOGIN_REQUIRED: null
});